var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"transition duration-500 ease-in m-auto rounded-lg bg-gray-200 h-1 flex items-center justify-center",class:{ 'bg-green-200': _vm.isDone }})}
var staticRenderFns = []

export { render, staticRenderFns }